<template lang="pug">    
<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <path d="m8.046 13.118 2.664-2.805L4.1 3.363c-1.468 1.547-1.468 4.055 0 5.611l3.945 4.144zm6.382-1.794c1.44.704 3.465.208 4.961-1.368 1.798-1.893 2.147-4.61.763-6.067-1.375-1.447-3.954-1.09-5.761.803-1.497 1.576-1.968 3.708-1.3 5.224l-9.187 9.676L5.23 20.99l6.486-6.811L18.194 21l1.327-1.398-6.477-6.82 1.384-1.458z" fill="currentColor"/>
    </g>
</svg>
</template>
